<style scoped>
.el-col-5{
  width: 30%;
}
.el-input-number {
    position: relative;
    display: inline-block;
    width: 180px;
    line-height: 34px;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
          <el-col :span="8"
          ><div class="search-area-div">会员名称：</div>
          <el-select v-model="page.tenantGuid" placeholder="请选择" class="w70f" filterable @change="selectTenantName(page.tenantGuid)">
            <el-option
              v-for="item in tableData"
              :key="item.tenantGuid"
              :label="item.tenantName"
              :value="item.tenantGuid">
            </el-option>
          </el-select>
          </el-col>
        <el-col :span="8"
          ><div class="search-area-div">算法名称：</div>
          <el-select v-model="page.repositoryGuid" placeholder="请选择" class="w70f" filterable @change="selectRepository(page.repositoryGuid)">
            <el-option
              v-for="item in repositoryNameList"
              :key="item.guid"
              :label="item.repositoryName"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col> 
        <!-- <el-col :span="8">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col> -->
      </el-row>
    </div>
    <div>
    <!-- <div class=" back-color-fff mt15 fl" style="padding: 16px;width:20%;">
      <el-table :data="tableData" border style="width: 100%;" @row-click="rowClick" highlight-current-row>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope"> 
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="会员名称" header-align="center" align="center"></el-table-column>   
      </el-table>
    </div> -->
    <div class=" back-color-fff mt15" style="padding: 16px;">
      <el-table :data="parameterList" border style="width: 100%;">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="parameter" label="参数名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="value" label="参数值" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="updateUserName" label="修改人" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="updateTime" label="修改时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(scope.row.valueType,scope.row.guid,scope.row.parameterGuid,scope.row.repositoryGuid,scope.row.parameter)">参数设置修改 | </a>
            <a class="txt-color" @click="upDefaultValue(scope.row)">恢复默认值</a> 
          </template>
        </el-table-column>      
      </el-table>
      <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination> 
    </div> 
    </div>
    <el-dialog
    title="参数设置"
    :visible.sync="dialogFormVisible"
    width="40%">
    <span>{{parameterSetTitle}}：</span>
    <!-- <el-input v-model="input" placeholder="请输入正整数" class="w49f"></el-input> -->
     <el-input-number v-model="ruleForm.value" :precision="0" :min="1" class="w49f"  v-if="valueType == '1'">> </el-input-number>
    <el-date-picker
      v-model="ruleForm.time"
      type="daterange"
      v-if="valueType == '6'" class="w49f"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-select v-model="ruleForm.value" filterable placeholder="请选择商品名称" class="w49f" v-if="valueType == '3' && parameterSetTitle == '商品名称'">
      <el-option
        v-for="(item,index) in goodsList"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="ruleForm.value" filterable placeholder="请选择周期类型" class="w49f" v-if="valueType == '3' && parameterSetTitle == '周期类型'">
      <el-option
        v-for="item in cycleList"
        :key="item.value" 
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="ruleForm.city" filterable placeholder="请选择城市" multiple collapse-tags  class="w49f" v-if="valueType == '4' && ruleForm.parameter == '总仓所在城市' || valueType == '4' && ruleForm.parameter == '指定RDC备选城市'">
      <el-option
        v-for="item in cityList"
        :key="item.value" 
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="ruleForm.city" filterable placeholder="请选择省份" multiple collapse-tags  class="w49f"  v-if="valueType == '4' && ruleForm.parameter == '总仓覆盖的省份' || valueType == '4' && ruleForm.parameter == '排除的省(不作为RDC的考虑范围)'">
      <el-option
        v-for="item in provinceList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-input v-model="ruleForm.value" class="ipt-sty w49f" placeholder="请输入药企名称"  v-if="valueType == '8'"></el-input> 
    <span slot="footer" class="dialog-footer">
    <el-button  plain size="medium" @click="dialogFormVisible = false">取 消</el-button>
    <el-button size="medium" type="info" @click="upDateForm()">确 定</el-button>
    </span>
    </el-dialog>
    <!-- <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm" 
        ref="ruleForm"
        label-width="120px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="RDC目标数量:" prop="value" v-if="valueType == '1'"> 
        <el-input-number v-model="ruleForm.value" :precision="0" :min="1" class="w100f"> </el-input-number>
        </el-form-item>
        <el-form-item label="时间选择:" prop="time" v-if="valueType == '6'" class="w100f">
        <el-date-picker
          v-model="ruleForm.time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        </el-form-item> 
        <el-form-item label="城市选择:" prop="city" v-if="valueType == '4' && ruleForm.parameter == '必须作为RDC的城市' || valueType == '4' && ruleForm.parameter == '指定RDC备选城市'">
              <el-select v-model="ruleForm.city" filterable placeholder="请选择" multiple collapse-tags  class="w100f">
                <el-option
                  v-for="item in cityList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="省份选择:" prop="city" v-if="valueType == '4' && ruleForm.parameter == '不送的省(比如厂家附近)' || valueType == '4' && ruleForm.parameter == '排除的省(不作为RDC的考虑范围)'">
              <el-select v-model="ruleForm.city" filterable placeholder="请选择" multiple collapse-tags  class="w100f">
                <el-option
                  v-for="item in provinceList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="药企名称:" prop="value" v-if="valueType == '8'">
        <el-input v-model="ruleForm.value" class="ipt-sty w100f" placeholder="药企名称"></el-input> 
        </el-form-item> 
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button> 
        <el-button size="medium" type="info" @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '参数设置/修改',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        tenantGuid: '',
        tenantName: '', 
        parameterGuid: '',
        parameter:'',
        repositoryGuid: '',
        repositoryName:'',
        time:'',
        value:'',
        city:[]
      },
      cycleList:[{value:'周',label:'周'},{value:'月',label:'月'}],
      goodsList:[],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        tenantName: '',
        repositoryGuid: '', 
        repositoryName: '',
        parameterGuid:'',
        tenantGuid: '', 
        repositoryName: '',
        parameter:'', 
      },
      dto:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0, 
        tenantGuid: '',
      },
      tableData: [], 
      multipleSelection: [],
      repositoryTypeList:[],
      repositoryNameList:[],
      parameterList:[],
      tenantList:[],
      valueType:'',
      cityList:[],
      provinceList:[],
      parameterSetTitle:''
    };
  },
  created() {
    // 列表 
    this.getrepositoryTypeList();
    this.getAllCityList();
    this.getAllProvinceList();
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        repositoryGuid: '', 
        repositoryName: '', 
      };
      self.getData(true);
    }, 
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val-tenant/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          if(res.data.data.records != null){
                    self.page.tenantName = res.data.data.records[0].tenantName;
                    self.ruleForm.tenantGuid = res.data.data.records[0].tenantGuid;
                    self.page.tenantGuid = res.data.data.records[0].tenantGuid;
                    self.getParamValList();
                    self.getGoodsList();
          }
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    selectRepository(repositoryGuid){
      let self = this;
       self.page.repositoryGuid = repositoryGuid;
       self.getData(false); 
    },
    getrepositoryTypeList() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.repositoryNameList = res.data.data.records;
          if(res.data.data.records != null){
            self.page.repositoryGuid = self.$router.history.current.query.repositoryGuid;
            self.getData(false); 
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    rowClick(row){ 
          let self = this;  
          self.ruleForm.tenantGuid = row.tenantGuid;
          self.page.tenantName = row.tenantName;
          self.getParamValList();
    },
    selectTenantName(tenantGuid){
          let self = this;  
          self.ruleForm.tenantGuid = tenantGuid;
          self.tableData.forEach(function(i){
             if(i.tenantGuid == tenantGuid){
                  self.page.tenantName = i.tenantName;
             }
          }) 
          self.getParamValList();
    },
    add(valueType,guid,parameterGuid,repositoryGuid,parameter){
              let self = this;
              self.ruleForm.guid = guid;
              self.ruleForm.parameter = parameter;
              self.parameterGuid = parameterGuid;
              self.ruleForm.repositoryGuid = repositoryGuid;
              self.parameterSetTitle = parameter; 
              self.ruleForm.value = '';
              self.ruleForm.city = [];
              if(valueType != null && valueType != ''){
                 self.valueType = valueType;
                 self.dialogFormVisible = true;
              }else{
                  self.$message.error("暂无可配置选项！");
              }
    }, 
    getGoodsList() {
      let self = this; 
      let promise = { 
            tenantGuid:self.ruleForm.tenantGuid,
            medCorpName:'哈药'
          };
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/get-import-goods-name`,promise).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data != null)
            res.data.data.forEach(function(i){
                    let item = {
                      value:i,
                      label:i
                    }
                    self.goodsList.push(item);
            }) 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    upDateForm() {
          let self = this;
          let valueList = [];
          if(self.valueType == '1' || self.valueType == '8'){
                if(self.ruleForm.value == null || self.ruleForm.value == ''){
                       self.$message.error("请输入值！");
                       return
                }else{
                       valueList.push(self.ruleForm.value.toString());
                }
          }else if(self.valueType == '3'){ 
                if(self.ruleForm.value == null && self.ruleForm.value == ''){
                       self.$message.error("请选择！");
                       return
                }else{
                       valueList.push(self.ruleForm.value.toString());
                } 
          }else if(self.valueType == '4'){
                if(self.ruleForm.city == null && self.ruleForm.city == ''){
                         self.$message.error("请选择！");
                         return
                  }else{
                         valueList = self.ruleForm.city;
                  }
          }else if(self.valueType == '6'){
                if(self.ruleForm.time == null && self.ruleForm.time == ''){
                         self.$message.error("请选择！");
                         return
                  }else{ 
                         valueList.push(self.$moment(self.ruleForm.time[0]).format('YYYY-MM-DD'),self.$moment(self.ruleForm.time[1]).format('YYYY-MM-DD'))
                  }
          }   
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid:self.ruleForm.tenantGuid,
            // parameterGuid:self.ruleForm.parameterGuid,
            // repositoryGuid:self.ruleForm.repositoryGuid, 
            value: JSON.stringify(valueList),  // JSON.stringify(
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.ruleForm.value = '';
              self.ruleForm.city = [];
              self.$message.success('参数设置成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          }); 
    },
    upDefaultValue(row) {
          let self = this; 
          let promise = {
            guid: row.guid,
            tenantGuid:row.tenantGuid, 
            value: row.defaultValue,  // JSON.stringify(
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
              self.$message.success('恢复默认值成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          }); 
    },
    getParamValList() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/get`,self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.parameterList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAllCityList() {
      let self = this; 
      self.api.get(`/${serverConfig.msAiAlgorithmService}/sys-conf/all-city/get`).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data != null)
            res.data.data.forEach(function(i){
                    let item = {
                      value:i,
                      label:i
                    }
                    self.cityList.push(item);
            }) 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAllProvinceList() {
      let self = this; 
      self.api.get(`/${serverConfig.msAiAlgorithmService}/sys-conf/all-province/get`).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data != null)
            res.data.data.forEach(function(i){
                    let item = {
                      value:i,
                      label:i
                    }
                    self.provinceList.push(item);
            }) 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    toLink(tenantGuid){
             this.$router.push({path: "/insuredManagement/insuredManagementDetails", query:{productGuid:this.$route.query.productGuid,tenantGuid:tenantGuid}})
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
